import React, { Component } from "react";
import TabElement from "../UI/Tabs";
import SearchForm from "../UI/SearchForm";
import Pagination from "../UI/Pagination";
import DatePickerUI from "../UI/DatePicker-f";
import { getCustomerOrders, getSingleOrder, getCSV } from "../../actions";
import { connect } from "react-redux";
import moment from "moment";

const today = moment(new Date()).format("YYYY-MM-DD");
const tomorrow = moment(new Date())
  .add(1, "days")
  .format("YYYY-MM-DD");

class CustomerOrders extends Component {
  state = {
    currentTab: "Daily Orders",
    page: 1,
    to_date: null,
    from_date: null,
    searchedValue: ""
  };

  componentDidMount() {
    this.props.getCustomerOrders(
      this.state.page,
      null,
      today,
      tomorrow,
      null,
      null
    );
  }

  onSubmitSearchHandler = value => {};

  onTabChangeHandler = tab => {
    this.setState({ from_date: null, to_date: null });
    switch (tab) {
      case "Daily Orders":
        this.props.getCustomerOrders(
          this.state.page,
          null,
          today,
          tomorrow,
          null,
          null
        );
        this.setState({ currentTab: "Daily Orders" });
        break;
      case "Rejected Orders":
        this.props.getCustomerOrders(
          this.state.page,
          "rejected",
          null,
          null,
          null,
          null
        );
        this.setState({ currentTab: "Rejected Orders" });
        break;
      default:
        this.setState({ currentTab: "Past Orders" });
        this.props.getCustomerOrders(
          this.state.page,
          null,
          null,
          tomorrow,
          null,
          null
        );
    }
  };

  onSubmitSearchHandler = searchValue => {
    this.setState({ searchedValue: searchValue });
    switch (this.state.currentTab) {
      case "Daily Orders":
        this.props.getCustomerOrders(
          this.state.page,
          null,
          today,
          tomorrow,
          searchValue,
          null
        );
        break;
      case "Rejected Orders":
        this.props.getCustomerOrders(
          this.state.page,
          "rejected",
          null,
          null,
          searchValue,
          null
        );
        break;
      default:
        this.props.getCustomerOrders(
          this.state.page,
          null,
          null,
          null,
          tomorrow,
          searchValue,
          null
        );
    }
  };

  pageChangeHandler = page => {
    switch (this.state.currentTab) {
      case "Daily Orders":
        this.props.getCustomerOrders(
          page.selected + 1,
          null,
          today,
          tomorrow,
          null,
          null
        );
        break;
      case "Rejected Orders":
        this.props.getCustomerOrders(
          page.selected + 1,
          "rejected",
          null,
          null,
          null,
          null
        );
        break;
      case "Past Orders":
        this.props.getCustomerOrders(
          page.selected + 1,
          null,
          null,
          tomorrow,
          null,
          null
        );
        break;
      default:
        return;
    }
  };

  getCSV = tab => {
    switch (this.state.currentTab) {
      case "Daily Orders":
        this.props
          .getCSV(
            this.state.page,
            null,
            this.state.from_date === null
              ? today
              : moment(this.state.from_date).format("YYYY-MM-DD"),
            this.state.to_date === null
              ? tomorrow
              : moment(this.state.to_date).format("YYYY-MM-DD"),
            this.state.searchedValue,
            null
          )
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "file.csv");
            link.click();
          });
        break;
      case "Rejected Orders":
        this.props
          .getCSV(
            this.state.page,
            "rejected",
            this.state.from_date === null
              ? null
              : moment(this.state.from_date).format("YYYY-MM-DD"),
            this.state.to_date === null
              ? null
              : moment(this.state.to_date).format("YYYY-MM-DD"),
            this.state.searchedValue,
            null
          )
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "file.csv");
            link.click();
          });
        break;
      case "Past Orders":
        this.props
          .getCSV(
            this.state.page,
            null,
            this.state.from_date === null
              ? null
              : moment(this.state.from_date).format("YYYY-MM-DD"),
            this.state.to_date === null
              ? tomorrow
              : moment(this.state.to_date).format("YYYY-MM-DD"),
            this.state.searchedValue,
            null
          )
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "file.csv");
            link.click();
          });
        break;
      default:
        return;
    }
  };

  onChangeDateHandler = (name, date, order) => {
    this.setState({ [name]: date });

    const dateObj = {
      from_date:
        this.state.from_date &&
        moment(this.state.from_date).format("YYYY-MM-DD"),
      to_date:
        this.state.to_date && moment(this.state.to_date).format("YYYY-MM-DD"),
      ...{ [name]: moment(date).format("YYYY-MM-DD") }
    };

    //It must be in YYYY-MM-DD HH:MM[:ss[.uuuuuu]][TZ] format."]
    switch (order) {
      case "Daily Orders":
        this.props.getCustomerOrders(
          this.state.page,
          null,
          dateObj.from_date === null ? today : dateObj.from_date,
          dateObj.to_date === null ? tomorrow : dateObj.to_date,
          this.state.searchedValue,
          null
        );
        break;
      case "Rejected Orders":
        this.props.getCustomerOrders(
          this.state.page,
          "rejected",
          dateObj.from_date,
          dateObj.to_date,
          this.state.searchedValue,
          null
        );
        break;
      default:
        this.props.getCustomerOrders(
          this.state.page,
          null,
          dateObj.from_date,
          dateObj.to_date === null ? tomorrow : dateObj.to_date,
          this.state.searchedValue,
          null
        );
    }
  };

  renderOrders = () => {
    let orders = null;
    if (!this.props.data || !this.props.data.customerOrders) return null;
    const result = this.props.data.result;
    if (!result || !result[0]) return null;

    orders = result.map((orderId, i) => {
      const order = this.props.data.customerOrders[orderId];

      return (
        <tr
          key={i}
          onClick={() => this.props.history.push(`customer-orders/${order.id}`)}
        >
          <td>{order.id}</td>
          <td>{order.orderAmount} SAR</td>
          <td>{order.driverId}</td>
          <td>{order.driverFirstName}</td>
          <td>{order.driverFirstName}</td>
          <td>{order.diverMobileNumber}</td>
        </tr>
      );
    });
    return orders;
  };

  render() {
    let pagination = null;
    if (
      this.props.data &&
      this.props.data.pageCount &&
      this.props.data.pageCount > 1
    ) {
      pagination = (
        <Pagination
          pageChangeHandler={this.pageChangeHandler}
          pageCount={this.props.data.pageCount}
        />
      );
    }
    const tabElements = [
      <div className="tab-content" key="1">
        <div className="table withHover mt-30">
          <table>
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Order Amount</th>
                <th>Driver ID</th>
                <th>Driver First Name</th>
                <th>Driver Last Name</th>
                <th>Driver Mobile Number</th>
              </tr>
            </thead>
            <tbody>{this.renderOrders()}</tbody>
          </table>
        </div>

        <div
          className="text-right mt-20"
          onClick={() => this.getCSV("Daily Orders")}
        >
          <button className="btn filled primary min-180">Export</button>
        </div>
      </div>,
      <div className="tab-content" key="2">
        <div className="row">
          <div className="col-xs-8 mt-30">
            <div className="row">
              <div className="col-xs-4">
                <DatePickerUI
                  label="From"
                  value={this.state.from_date}
                  name="from_date"
                  onChange={(name, date) =>
                    this.onChangeDateHandler(name, date, "Rejected Orders")
                  }
                />
              </div>
              <div className="col-xs-4 ml-30">
                <DatePickerUI
                  label="To"
                  value={this.state.to_date}
                  name="to_date"
                  onChange={(name, date) =>
                    this.onChangeDateHandler(name, date, "Rejected Orders")
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <div className="table withHover mt-30">
          <table>
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Order Amount</th>
                <th>Driver ID</th>
                <th>Driver First Name</th>
                <th>Driver Last Name</th>
                <th>Driver Mobile Number</th>
              </tr>
            </thead>
            <tbody>{this.renderOrders()}</tbody>
          </table>
        </div>

        <div
          className="text-right mt-20"
          onClick={() => this.getCSV("Rejected Orders")}
        >
          <button className="btn filled primary min-180">Export</button>
        </div>
      </div>,
      <div className="tab-content" key="3">
        <div className="row">
          <div className="col-xs-8 mt-30">
            <div className="row">
              <div className="col-xs-4">
                <DatePickerUI
                  label="From"
                  value={this.state.from_date}
                  name="from_date"
                  onChange={(name, date) =>
                    this.onChangeDateHandler(name, date, "Past Orders")
                  }
                />
              </div>
              <div className="col-xs-4 ml-30">
                <DatePickerUI
                  label="To"
                  value={this.state.to_date}
                  name="to_date"
                  onChange={(name, date) =>
                    this.onChangeDateHandler(name, date, "Past Orders")
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <div className="table withHover mt-30">
          <table>
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Order Amount</th>
                <th>Driver ID</th>
                <th>Driver First Name</th>
                <th>Driver Last Name</th>
                <th>Driver Mobile Number</th>
              </tr>
            </thead>
            <tbody>{this.renderOrders()}</tbody>
          </table>
        </div>

        <div
          className="text-right mt-20"
          onClick={() => this.getCSV("Past Orders")}
        >
          <button className="btn filled primary min-180">Export</button>
        </div>
      </div>
    ];

    return (
      <React.Fragment>
        <div className="page-title">
          <div className="container">
            <div className="row flex-center-y justify-between">
              <div className="col-xs-9">
                <h1 className="color-grey">Customer Orders</h1>
              </div>
              <SearchForm onSubmit={this.onSubmitSearchHandler} />
            </div>
          </div>
        </div>
        <div className="container box py-15">
          <TabElement
            labels={["Daily Orders", "Rejected Orders", "Past Orders"]}
            onTabChange={this.onTabChangeHandler}
          >
            {tabElements}
          </TabElement>
          {pagination}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.foodna
  };
};

const mapDispatchToProps = dispatch => {
  return {
    // getCustomerRejectedOrders: (page, searchValue, date) =>
    //   dispatch(getCustomerRejectedOrders(page, searchValue, date)),
    getCustomerOrders: (
      page,
      type,
      def_fromDate,
      def_toDate,
      searchValue,
      date
    ) =>
      dispatch(
        getCustomerOrders(
          page,
          type,
          def_fromDate,
          def_toDate,
          searchValue,
          date
        )
      ),
    getSingleOrder: id => dispatch(getSingleOrder(id)),
    getCSV: (page, type, def_fromDate, def_toDate, searchValue, date) =>
      dispatch(getCSV(page, type, def_fromDate, def_toDate, searchValue, date))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerOrders);



// WEBPACK FOOTER //
// ./src/components/Customer-web-portal/CustomerOrders.js